import type { Apartment } from '../types';

const ALL_APARTMENT_AMENITIES = [
  'Entire Apartment',
  'Private Kitchen',
  'Private Bathroom',
  'Sea View',
  'Mountain View',
  'Air Conditioning',
  'Flat-screen TV',
  'Free WiFi',
  'Landmark View',
  'Terrace',
  'Free Toiletries',
  'Kitchen',
  'Toilet',
  'Bath or Shower',
  'Towels',
  'Linen',
  'Socket Near Bed',
  'Tile or Marble Floor',
  'Sitting Area',
  'TV',
  'Slippers',
  'Refrigerator',
  'Iron',
  'Hair Dryer',
  'Kitchenware',
  'Kitchenette',
  'Extra Long Beds (> 2m)',
  'Electric Kettle',
  'Outdoor Furniture',
  'Wardrobe',
  'Stovetop',
  'Toaster',
  'Dining Table',
  'Upper Floors Accessible by Stairs Only',
  'Detached',
  'Clothes Rack',
  'Toilet Paper',
  'Hand Sanitizer',
] as const;

// Villa Spilia — real apartments based on existing villaspilia.gr content.
// Coastal/Aegean placeholder imagery from Unsplash; replace with owner photos later.
// Capacity per spec: 2 suites (2 adults) + 1 suite (2 adults + 1 child)
export const apartmentsData: Apartment[] = [
  {
    id: 1,
    name: 'Suite One',
    description:
      'Set on the first floor of the old Spilia mansion with sweeping Ionian Sea views from inside the room. A twin bedroom convertible to a double, a private bathroom with rain shower, and a separate living-kitchen opening onto a balcony and an outdoor terrace lounge.',
    amenities: [...ALL_APARTMENT_AMENITIES],
    capacityAdults: 2,
    capacityChildren: 0,
    sortOrder: 1,
    mainImageUrl: '/images/gallery/suite-one/room1_main.jpg',
    homeImageUrl: '/images/home/suite-one.jpg',
    photos: [
      { id: 1, imageUrl: '/images/gallery/suite-one/room1_l1.jpg', caption: 'Living room with sea-facing balcony', displayOrder: 1 },
      { id: 2, imageUrl: '/images/gallery/suite-one/room1_l2.jpg', caption: 'Twin bedroom with linen drapes', displayOrder: 2 },
      { id: 3, imageUrl: '/images/gallery/suite-one/room1_l3.jpg', caption: 'Kitchen and dining nook', displayOrder: 3 },
      { id: 4, imageUrl: '/images/gallery/suite-one/room1_l4.jpg', caption: 'Private bathroom', displayOrder: 4 },
      { id: 5, imageUrl: '/images/gallery/suite-one/room1_l5.jpg', caption: 'Private bathroom', displayOrder: 4 },
      { id: 6, imageUrl: '/images/gallery/suite-one/room1_l6.jpg', caption: 'Private bathroom', displayOrder: 4 },
      { id: 7, imageUrl: '/images/gallery/suite-one/room1_l7.jpg', caption: 'Private bathroom', displayOrder: 4 },
      { id: 8, imageUrl: '/images/gallery/suite-one/room1_l8.jpg', caption: 'Private bathroom', displayOrder: 4 },
      { id: 9, imageUrl: '/images/gallery/suite-one/room1_l9.jpg', caption: 'Private bathroom', displayOrder: 4 },
    ],
  },
  {
    id: 2,
    name: 'Suite Two',
    description:
      'A first-floor suite mirroring Suite One, with a quiet twin bedroom that converts to a double and a fully equipped kitchen-living room. Step out onto the balcony and outdoor terrace to take in the village rooftops and the sea beyond.',
    amenities: [...ALL_APARTMENT_AMENITIES],
    capacityAdults: 2,
    capacityChildren: 0,
    sortOrder: 2,
    mainImageUrl: '/images/gallery/suite-two/room2_main.jpg',
    homeImageUrl: '/images/home/suite-two.jpg',
    photos: [
      { id: 10, imageUrl: '/images/gallery/suite-two/room2_l1.jpg', caption: 'Sunlit living space', displayOrder: 1 },
      { id: 11, imageUrl: '/images/gallery/suite-two/room2_l2.jpg', caption: 'Bedroom with traditional linens', displayOrder: 2 },
      { id: 12, imageUrl: '/images/gallery/suite-two/room2_l3.jpg', caption: 'Kitchen detail', displayOrder: 3 },
      { id: 13, imageUrl: '/images/gallery/suite-two/room2_l4.jpg', caption: 'Outdoor terrace lounge', displayOrder: 4 },
      { id: 14, imageUrl: '/images/gallery/suite-two/room2_l5.jpg', caption: 'Village view from terrace', displayOrder: 5 },
      { id: 15, imageUrl: '/images/gallery/suite-two/room2_l6.jpg', caption: 'Sunset over the Ionian', displayOrder: 6 },

    ],
  },
  {
    id: 3,
    name: 'Suite Three',
    description:
      'A ground-floor suite that opens straight onto a private outdoor terrace with table and chairs. Inside, a twin bedroom convertible to a double plus a child bed, full kitchen and a calm living room — ideal for a small family.',
    amenities: [...ALL_APARTMENT_AMENITIES],
    capacityAdults: 2,
    capacityChildren: 1,
    sortOrder: 3,
    mainImageUrl: '/images/gallery/suite-three/room3_main_l.jpg',
    homeImageUrl: '/images/home/suite-three.jpg',
    photos: [
      { id: 21, imageUrl: '/images/gallery/suite-three/room3_l1.jpg', caption: 'Family-friendly bedroom', displayOrder: 1 },
      { id: 22, imageUrl: '/images/gallery/suite-three/room3_l2.jpg', caption: 'Open kitchen', displayOrder: 2 },
      { id: 16, imageUrl: '/images/gallery/suite-three/room3_l3.jpg', caption: 'Living room', displayOrder: 3 },
      { id: 17, imageUrl: '/images/gallery/suite-three/room3_l4.jpg', caption: 'Private terrace', displayOrder: 4 },
      { id: 18, imageUrl: '/images/gallery/suite-three/room3_l5.jpg', caption: 'Sunset over the Ionian', displayOrder: 5 },
      { id: 19, imageUrl: '/images/gallery/suite-three/room3_l6.jpg', caption: 'Sunset over the Ionian', displayOrder: 6 },
      { id: 20, imageUrl: '/images/gallery/suite-three/room3_l7.jpg', caption: 'Sunset over the Ionian', displayOrder: 7   },
    ],
  },
];

export function getApartmentById(id: number): Apartment | undefined {
  return apartmentsData.find((a) => a.id === id);
}
export function getAllApartments(): Apartment[] {
  return [...apartmentsData].sort((a, b) => a.sortOrder - b.sortOrder);
}
export function isValidApartmentId(id: number): boolean {
  return apartmentsData.some((a) => a.id === id);
}
